import RechargeGateway from '@/gateway/Recharge';

export default class CustomerUtils {
  static async hasActiveSubs(email) {
    if (!email) return false;
    const activeSubs = await RechargeGateway.getSubscriptions();
    return activeSubs.length > 0;
  }
}
